<template>
  <div>
    <!-- TODO: refactor markup using the data in 'menu'Secondary Menu Component -->
    <!-- {{ menu }} -->
    <span v-for="(route, index) in menu" :key="index">
      <router-link :to="{name:route.routeName}" class="nav-link chr-nav-link py-0">
        <b-icon :icon="route.icon" class="rounded bg-primary p-1" variant="light"></b-icon>
      </router-link>
    </span>
  </div>
</template>

<script>
import { secondary } from '../nav'

export default {
  data () {
    return {
      menu: secondary
    }
  }
}
</script>
